import { StatusLabelTypes, TagColor } from '@factorialco/deprecated-design-system'
import { TasksValueObjectsTaskStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface ITaskStatus {
  title: string
  type: TagColor
  statusType: StatusLabelTypes
  status: TasksValueObjectsTaskStatusEnum
}

export const defaultStatus = (): ITaskStatus => {
  return {
    title: i18n.t('tasks.status.todo'),
    type: TagColor.grey,
    statusType: 'neutral',
    status: 'todo',
  }
}

export const taskStatuses = (): ITaskStatus[] => [
  {
    title: i18n.t('tasks.status.todo'),
    type: TagColor.grey,
    statusType: 'neutral',
    status: 'todo',
  },
  {
    title: i18n.t('tasks.status.in_progress'),
    type: TagColor.malibu,
    statusType: 'info',
    status: 'in_progress',
  },
  {
    title: i18n.t('tasks.status.done'),
    type: TagColor.lime,
    statusType: 'positive',
    status: 'done',
  },
  {
    title: i18n.t('tasks.status.discarded'),
    type: TagColor.tangerine,
    statusType: 'warning',
    status: 'discarded',
  },
]

export const statusOption = (status?: TasksValueObjectsTaskStatusEnum | null) => {
  return status
    ? taskStatuses().find((taskStatus) => taskStatus.status === status)
    : taskStatuses()[0]
}

export const isValidTaskStatus = (status: string): status is TasksValueObjectsTaskStatusEnum => {
  return ['todo', 'in_progress', 'done', 'discarded'].includes(status)
}
